<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="page-main-sidebar" position="left" lockedOpen="gt-md">
        <page-main-sidebar></page-main-sidebar>
    </fuse-sidebar>

    <div class="center" style="overflow-y: scroll;">

        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
            <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                  fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                <div class="h2 mb-24">{{'Page data'|translate}}</div>
                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                        <mat-label>{{'Name'|translate}}</mat-label>
                        <input matInput formControlName="tagName" required>
                        <mat-error>{{'Name is required!'|translate}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="content">

                    <mat-tab-group fxLayout="column" fxFlex="100">
                        <mat-tab label="{{'Language'|translate}} - {{pageLanguage.value.language.name}}" formArrayName="languages" *ngFor="let pageLanguage of pageLanguages().controls; index as i">
                            <div class="tab-content p-24" fusePerfectScrollbar [formGroupName]="i">


                                <div class="section" fxLayout="column">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                        <mat-checkbox formControlName="visible" fxFlex="100">
                                            <mat-label>{{'Visible'|translate}}</mat-label>
                                        </mat-checkbox>
                                    </div>

                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="100">
                                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                            <mat-label>{{'Name'|translate}}</mat-label>
                                            <input matInput formControlName="name">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                            <mat-label>{{'Slug'|translate}}</mat-label>
                                            <input matInput formControlName="slug">
                                        </mat-form-field>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="100">
                                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                                            <mat-label>{{'Keywords'|translate}}</mat-label>
                                            <input matInput formControlName="keywords">
                                        </mat-form-field>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="100">
                                        <mat-form-field appearance="outline" fxFlex="100">
                                            <mat-label>{{'Short description'|translate}}</mat-label>
                                            <textarea matInput formControlName="shortDescription"></textarea>
                                        </mat-form-field>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="100">
                                        <mat-form-field appearance="outline" fxFlex="100">
                                            <mat-label>{{'Description'|translate}}</mat-label>
                                            <textarea matInput formControlName="description"></textarea>
                                        </mat-form-field>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="100">
                                        <mat-form-field appearance="outline" fxFlex="100">
                                            <mat-label>{{'Meta description'|translate}}</mat-label>
                                            <textarea matInput formControlName="metaDescription"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button mat-raised-button type="submit" color="accent">
                            {{'Save'|translate}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
